<div class="container h-100 p-4 position-relative">
  <div class="modal-header position-absolute" (click)="closeModal()">
    <img src="assets/images/icons/cross-btn.svg" alt="close-btn" />
  </div>

  <div class="row mt-3">
    <!-- Main Image Section -->
    <div class="col-md-6 d-flex flex-column">
      <div class="main-image-container position-relative" style="height: 350px">
        <!-- Left Navigation Button -->
        <button
          *ngIf="photos.length > 1"
          class="btn btn-outline-secondary position-absolute left-arrow"
          [class.disabled]="isLeftDisabled()"
          [disabled]="isLeftDisabled()"
          (click)="navigateMainImages(-1)"
        >
          <mat-icon aria-hidden="true">arrow_back</mat-icon>
        </button>

        <!-- Main Image -->
        <img
          [src]="mainImage"
          alt="Main Image"
          class="travel-story-img rounded slide-animation"
          (mouseover)="stopAutoplay()"
          (mouseleave)="startAutoplay()"
        />

        <button
          *ngIf="photos.length > 1"
          class="btn btn-outline-secondary position-absolute right-arrow"
          [class.disabled]="isRightDisabled()"
          [disabled]="isRightDisabled()"
          (click)="navigateMainImages(1)"
        >
          <mat-icon aria-hidden="true">arrow_forward</mat-icon>
        </button>
      </div>

      <!-- Thumbnails Section -->
      <div
        class="thumbnails-container d-flex justify-content-center align-items-center mt-3"
        *ngIf="photos.length > 0"
      >
        <div
          class="thumbnails-wrapper overflow-hidden"
          [ngStyle]="{ width: visibleThumbnails * thumbnailWidth + 40 + 'px' }"
        >
          <div
            class="thumbnails d-flex"
            [ngStyle]="{
              transform:
                'translateX(-' + currentStartIndex * thumbnailWidth + 'px)'
            }"
          >
            <ng-container *ngFor="let photo of photos; let i = index">
              <img
                [src]="photo"
                alt="Thumbnail"
                class="img-thumbnail mx-1"
                [ngClass]="{ active: photo === mainImage }"
                (click)="selectThumbnail(i)"
              />
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Story Section -->
    <div class="col-md-6">
      <h5 class="heading">{{ travellerStoriesData.storyTitle }}</h5>
      <div
        *ngIf="travellerStoriesData.rating"
        class="star-rating-container mb-2"
      >
        <div
          *ngFor="let star of getStarsArray(travellerStoriesData?.rating || 0)"
          class="star-rating-img"
          [ngClass]="{ 'filled-star': star.filled, 'blank-star': !star.filled }"
        ></div>
      </div>
      <p class="fs-12">{{ travellerStoriesData.storyDescription }}</p>
    </div>
  </div>
</div>
